// Animate On Scroll Options
// https://github.com/michalsnik/aos
import AOS from 'aos'

AOS.init({
    disable: 'phone',
    duration: 400,
    offset: -80,
    once: true,
})